export default __webpack_public_path__ + "clientLogo_aa.svg";